import { site } from '../data/site'

export default function InfoCards() {
  const items = [
    {
      label: 'GitHub',
      value: site.github.replace(/^https?:\/\//, ''),
      href: site.github,
      icon: (
        <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
          <path d="M12 .5A11.5 11.5 0 0 0 .5 12a11.5 11.5 0 0 0 7.9 10.9c.6.1.8-.2.8-.6v-2.2c-3.2.7-3.9-1.4-3.9-1.4-.5-1.3-1.3-1.7-1.3-1.7-1.1-.7.1-.7.1-.7 1.2.1 1.8 1.2 1.8 1.2 1.1 1.8 2.8 1.3 3.5 1 .1-.8.4-1.3.8-1.6-2.6-.3-5.3-1.3-5.3-5.7 0-1.3.5-2.3 1.2-3.1-.1-.3-.5-1.5.1-3.2 0 0 1-.3 3.2 1.2a11 11 0 0 1 5.8 0C17.2 4 18.2 4.3 18.2 4.3c.6 1.7.2 2.9.1 3.2.8.8 1.2 1.8 1.2 3.1 0 4.4-2.7 5.4-5.3 5.7.4.3.8 1 .8 2.1v3.1c0 .3.2.7.8.6A11.5 11.5 0 0 0 23.5 12 11.5 11.5 0 0 0 12 .5z" />
        </svg>
      ),
    },
    {
      label: 'Email',
      value: site.email,
      href: `mailto:${site.email}`,
      icon: (
        <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m3 7 9 6 9-6" />
        </svg>
      ),
    },
    {
      label: 'Paper',
      value: site.paper.title,
      sub: site.paper.venue,
      href: site.paper.url,
      icon: (
        <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 3h9l4 4v14H6z" />
          <path d="M14 3v5h5M9 13h7M9 17h5" />
        </svg>
      ),
    },
  ]

  return (
    <section id="links" className="w-full px-6 sm:px-10 lg:px-16 py-16">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold text-navy">
            프로젝트 & 연락처
          </h2>
          <p className="text-navy/60 mt-2 text-sm">
            소스 코드, 문의, 관련 논문을 여기에서 확인하세요.
          </p>
        </div>
      </div>

      <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((it) => (
          <li key={it.label}>
            <a
              href={it.href}
              target={it.href.startsWith('mailto') ? undefined : '_blank'}
              rel="noreferrer"
              className="group block h-full rounded-2xl border border-black/5 bg-white p-6 shadow-card hover:shadow-md hover:border-brand/30 transition"
            >
              <div className="flex items-center gap-3 text-navy/60">
                <span className="inline-flex w-9 h-9 items-center justify-center rounded-lg bg-muted group-hover:bg-brand/10 group-hover:text-brand-dark transition">
                  {it.icon}
                </span>
                <span className="text-xs font-semibold tracking-wider uppercase">
                  {it.label}
                </span>
                <span className="ml-auto text-navy/30 group-hover:text-brand transition">
                  ↗
                </span>
              </div>
              <div className="mt-4 font-semibold text-navy break-all leading-snug">
                {it.value}
              </div>
              {it.sub && (
                <div className="mt-1 text-xs text-navy/50">{it.sub}</div>
              )}
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}
